import { Injectable, Inject } from "@angular/core";
import { HttpService, URI } from "../shared/http.service";
import { RecycabilityCalculation, AssessmentModel } from "./types";
import { HttpHeaders } from "@angular/common/http";

@Injectable()
export class ReportHttpService {
  constructor(private httpService: HttpService) { }
  
  public getDebug(id: number, calculation: RecycabilityCalculation) {
    return this.httpService.get<AssessmentModel>(URI`/api/report/${id}/debug`, { calculation });
  }
  
  public get(id: number, calculation: RecycabilityCalculation) {
    return this.httpService.get<AssessmentModel>(URI`/api/report/${id}`, { calculation });
  }
}